var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import classnames from 'classnames';
import { observable } from 'mobx';
import * as React from 'react';
import { GridWrapper } from '../../../grid/Grid';
import { Hr, Paragraph } from '../../../elements';
import ReportNavigation from '../ReportNavigation';
// removed import of scss-style
class ReadReportMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = { sticky: false };
        this.container = React.createRef();
        this.spacer = React.createRef();
        this.content = React.createRef();
        this.stickyHeader = React.createRef();
    }
    componentDidMount() {
        this.resizeListener = this.onResize.bind(this);
        this.scrollListener = this.onScroll.bind(this);
        window.addEventListener('resize', this.resizeListener);
        window.addEventListener('scroll', this.scrollListener);
        this.handleScroll();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeListener);
        window.removeEventListener('scroll', this.scrollListener);
    }
    onScroll() {
        this.handleScroll();
    }
    onResize() {
        this.handleScroll();
    }
    handleScroll() {
        const stickyHeader = this.stickyHeader.current;
        const content = this.content.current;
        const spacer = this.spacer.current;
        if (!stickyHeader) {
            return;
        }
        const rect = spacer.getBoundingClientRect();
        this.setState({ sticky: rect.top < 0 });
        const percent = Math.min(1, -Math.min(0, rect.top) / 20);
        const extraSpace = 17 + 24 * percent;
        stickyHeader.style.opacity = percent + '';
        stickyHeader.style.height = extraSpace + 'px';
        spacer.style.height = content.clientHeight - extraSpace + 'px';
    }
    render() {
        const reportStore = this.props.store;
        const { reportPackageName, order } = reportStore;
        const { firstName, lastName } = order.candidate;
        return (React.createElement("div", { ref: this.container, className: classnames('ReadReportMenu', {
                'ReadReportMenu--sticky': this.state.sticky
            }) },
            React.createElement("div", { ref: this.spacer, className: 'ReadReportMenu__Spacer' }),
            React.createElement("div", { ref: this.content, className: 'ReadReportMenu__StickyMenu' },
                React.createElement(GridWrapper, { className: "" },
                    React.createElement("div", { ref: this.stickyHeader, className: 'ReadReportMenu__NameAndTitle' },
                        React.createElement(Paragraph, null,
                            React.createElement("b", null, `${firstName} ${lastName}`),
                            this.props.isCup && ` - ${reportPackageName}`)),
                    React.createElement(ReportNavigation, { store: reportStore })),
                reportStore.showLanguageSwitch && React.createElement("div", { onClick: () => {
                        reportStore.changeLanguage();
                    }, style: { cursor: 'pointer' } }, "Byt spr\u00E5k"),
                React.createElement(Hr, null))));
    }
}
__decorate([
    observable
], ReadReportMenu.prototype, "sticky", void 0);
export default ReadReportMenu;
